"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = goodDetailsReducer;

var _underscore = _interopRequireDefault(require("underscore"));

var _immutable = require("immutable");

var _GoodImageTypes = _interopRequireDefault(require("marketplace-lib/constants/GoodImageTypes"));

var _ModuleImageTypes = _interopRequireDefault(require("marketplace-lib/constants/ModuleImageTypes"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _GoodTagTypes = _interopRequireDefault(require("../constants/GoodTagTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _utils = require("../utils/utils");

var initialState = (0, _immutable.fromJS)({
  requestStatus: _RequestStatusTypes.default.UNINITIALIZED,
  averageRating: 0,
  certifications: [],
  children: [],
  codingType: [],
  contactEmail: '',
  customModuleCompatibilityTag: [],
  customModulePurposeTag: [],
  customModuleImages: [],
  description: '',
  downloads: '',
  goodId: '',
  documentationLink: '',
  exampleLink: '',
  imageUrl: '',
  smallImageUrl: '',
  family: '',
  featureTags: [],
  hasReviewed: false,
  industryTag: [],
  templatePurposeTag: [],
  isFree: false,
  layoutTag: [],
  newVersionAvailable: false,
  packCounts: [],
  parents: [],
  price: null,
  providerName: '',
  providerPortalId: null,
  providerWebsite: '',
  purchaseError: '',
  purchaseInProcess: false,
  reviews: [],
  showSitePagePql: false,
  stripeProvider: true,
  subType: '',
  type: '',
  totalChildren: 0,
  transactionId: null,
  goodName: '',
  urlToken: ''
});

function getImgUrl(goodInfo, goodImageType) {
  if (goodInfo.goodImages) {
    return goodInfo.goodImages[goodImageType];
  }

  return '';
}

function getCustomModuleImages(goodInfo) {
  return _ModuleImageTypes.default.reduce(function (images, imageType) {
    var image = getImgUrl(goodInfo, imageType);

    if (image) {
      images.push(image);
    }

    return images;
  }, []);
}

function getLocalizedTextField(field, goodInfo) {
  if (goodInfo.goodText) {
    return (0, _utils.getEnglishTextFieldFromGoodTextObj)(field, goodInfo.goodText);
  }

  return '';
}

function parseTag(payload, tag) {
  if (_underscore.default.isObject(payload.goodInfo.goodTags) && _underscore.default.isArray(payload.goodInfo.goodTags[tag])) {
    return payload.goodInfo.goodTags[tag];
  }

  return null;
}

function goodDetailsReducer() {
  var goodDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.GOOD_DETAILS_REQUESTED:
      if (action.error) {
        return goodDetails.set('requestStatus', _RequestStatusTypes.default.FAILED);
      }

      return goodDetails.set('requestStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.GOOD_DETAILS_RECEIVED:
      return goodDetails.merge({
        requestStatus: _RequestStatusTypes.default.SUCCEEDED,
        averageRating: action.payload.reviewInfo ? action.payload.reviewInfo.rating : 0,
        certifications: action.payload.providerInfo.awards || [],
        children: action.payload.children,
        codingType: parseTag(action.payload, _GoodTagTypes.default.COS_TEMPLATE_CODING_TYPE) || [],
        contactEmail: action.payload.providerInfo.supportEmail || action.payload.providerInfo.contactEmail,
        customModuleCompatibilityTag: parseTag(action.payload, _GoodTagTypes.default.MODULE_COMPATIBILITY) || [],
        customModulePurposeTag: parseTag(action.payload, _GoodTagTypes.default.MODULE_PURPOSE) || [],
        customModuleImages: getCustomModuleImages(action.payload.goodInfo),
        description: getLocalizedTextField('DESCRIPTION', action.payload.goodInfo),
        downloads: action.payload.downloadCount,
        documentationLink: action.payload.goodInfo.documentationLink,
        exampleLink: action.payload.goodInfo.exampleLink,
        featureTags: parseTag(action.payload, _GoodTagTypes.default.COS_TEMPLATE_FEATURES) || [],
        goodId: action.payload.goodInfo.goodId,
        hasReviewed: action.payload.customerPurchaseInfo ? action.payload.customerPurchaseInfo.reviewed : false,
        imageUrl: getImgUrl(action.payload.goodInfo, _GoodImageTypes.default.SCREENSHOT),
        smallImageUrl: getImgUrl(action.payload.goodInfo, _GoodImageTypes.default.MARKETING_IMAGE_SMALL),
        industryTag: parseTag(action.payload, _GoodTagTypes.default.INDUSTRY) || [],
        templatePurposeTag: parseTag(action.payload, _GoodTagTypes.default.COS_TEMPLATE_INTENT) || [],
        isFree: action.payload.goodInfo.free,
        layoutTag: parseTag(action.payload, _GoodTagTypes.default.COS_TEMPLATE_LAYOUT) || [],
        newVersionAvailable: action.payload.newVersionAvailable || false,
        packCounts: action.payload.packCounts || [],
        parents: action.payload.parents || [],
        price: action.payload.goodInfo.price,
        providerName: action.payload.providerInfo.company,
        providerPortalId: action.payload.providerInfo.portalId,
        providerWebsite: action.payload.providerInfo.website,
        purchaseInProcess: false,
        reviews: action.payload.reviewInfo ? action.payload.reviewInfo.reviews : [],
        showSitePagePql: action.payload.pqlInfo ? action.payload.pqlInfo.showSitePageAddOn : false,
        stripeProvider: action.payload.providerInfo.stripeProvider,
        subType: action.payload.goodInfo.subType,
        type: action.payload.goodInfo.type,
        totalChildren: action.payload.totalChildren || 0,
        transactionId: action.payload.customerPurchaseInfo ? action.payload.customerPurchaseInfo.transactionId : null,
        goodName: getLocalizedTextField('NAME', action.payload.goodInfo),
        urlToken: action.payload.goodInfo.urlToken
      });

    case _ActionTypes.default.PURCHASED_WITH_STRIPE:
      if (action.error) {
        return goodDetails.set('purchaseError', action.payload.message);
      }

      return goodDetails.set('purchaseInProcess', true);

    case _ActionTypes.default.STRIPE_PURCHASE_COMPLETED:
      return goodDetails.set('purchaseInProcess', false);

    case _ActionTypes.default.PURCHASED_WITH_PAYPAL:
      if (action.error) {
        return goodDetails.set('purchaseError', action.payload.message);
      }

      return goodDetails.set('purchaseInProcess', true);

    case _ActionTypes.default.DISMISSED_PURCHASE_ERROR:
      return goodDetails.merge({
        purchaseError: '',
        purchaseInProcess: false
      });

    case _ActionTypes.default.REVIEW_SUBMITTED_FROM_DETAILS_SUCCESS:
      return goodDetails.merge({
        hasReviewed: true,
        reviews: goodDetails.get('reviews').push((0, _immutable.Map)(action.payload.review))
      });

    case _ActionTypes.default.REDELIVERING_GOOD:
      return goodDetails.merge({
        newVersionAvailable: false
      });

    case _ActionTypes.default.GOOD_DETAILS_RESET:
      return initialState;

    default:
      return goodDetails;
  }
}

module.exports = exports.default;